import Client from "./client";

const baseUrl = `/api/1/constants`;

function constantApi() {
  return {
    getConstants: () => {
      const url = baseUrl;
      return Client.get(url);
    },
    getActivities: () => {
      const url = "/api/1/users/activities";
      return Client.get(url);
    },
  };
}

export default constantApi();
